<template lang="pug">
	
	.youth-presentation
		
		.container
			.youth-presentation-text
				p.text(v-html="translate('youth.text')")
			.mobile-image(v-if="isMobile")
				responsive-image(src="assets/images/youth-duo.png" width="504" height="504")
			.youth-presentation-quote
				quote
					blockquote(slot="quote") {{translate('youth.quote')}}
					p(slot="translation").translation {{translate('youth.translation')}}
					

			.wrap-image.image-1
				responsive-image(:src="crewImg" height="253" width="253")

			.wrap-image.image-2
				responsive-image(:src="duoImg" width="504" height="504")

			.wrap-image.image-3
				responsive-image(:src="trioImg" height="360" width="360")

			.wrap-image.image-4
				responsive-image(:src="momImg" height="360" width="360")

			.wrap-image.image-5
				responsive-image(:src="studenImg" height="144" width="144")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import { TweenMax } from 'gsap'
	import Globals from '~utils/Globals.js'
	import Scrollable from '~abstracts/scrollable'
	import Quote from '~components/content-elements/quote.vue'
	import ResponsiveImage from '~components/responsive-image.vue'

	import YouthCrew from "assets/images/youth-crew.png"
	import YouthDuo from "assets/images/youth-duo.png"
	import YouthTrio from "assets/images/youth-trio.png"
	import YouthMom from "assets/images/youth-mom.png"
	import YouthStuden from "assets/images/youth-student.png"

  	@Component({
		name: 'YouthPresentation',
		components: { ResponsiveImage,Quote },
		data: function () {
			return {
				state : Globals.state,
				crewImg: YouthCrew,
				duoImg: YouthDuo,
				trioImg: YouthTrio,
				momImg: YouthMom,
				studenImg: YouthStuden 
			}
		},
		computed : {
			isMobile: function () {
				return this.state.isMobile
			},
			isTablet: function () {
				return this.state.isTablet
			}
		}
	})

	class YouthPresentation extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$image1 = this.$el.querySelector('.image-1')
			this.$image2 = this.$el.querySelector('.image-2')
			this.$image3 = this.$el.querySelector('.image-3')
			this.$image4 = this.$el.querySelector('.image-4')
			this.$image5 = this.$el.querySelector('.image-5')
		}

		initTimeline () {
			super.initTimeline()

			this.tl.fromTo(this.$image1,1,{y:200},{y:-200},0)
			this.tl.fromTo(this.$image2,1,{y:-100},{y:100},0)
			this.tl.fromTo(this.$image3,1,{y:0},{y:100},0)
			this.tl.fromTo(this.$image4,1,{y:50},{y:-50},0)
			this.tl.fromTo(this.$image5,1,{y:200},{y:-50},0)

		}

		raf (y) {
			super.raf(y)	
		}

		_resize () {
			super._resize()

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height + window.innerHeight
			}

			if(!this.isMobile) {
				this.initTimeline()
			}

		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default YouthPresentation

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.youth-presentation
		width 100%
		padding-bottom 40%
		position relative
		padding-top 50px

		.youth-presentation-text
			
			width 20%
			margin-left 10%
			position relative
			z-index 50

			+break(xs)
				width 100%
				margin-left 0%

			.text
				font-size em(16px)
				line-height em(24px,16px)
				color #fff
				font-family $FONT_THIRDLY
				width 100%

				a
					color $COLOR_WHITE
					font-weight 700

				+break(xs)
					font-size em(20px)

		.youth-presentation-quote
			width 100%
			max-width 1050px
			margin auto
			text-align center
			margin-top 60px
			position relative
			z-index 50

			+break(xs)
				margin-top 30px

		.mobile-image
			width 100%
			margin 20px 0

		.wrap-image
			position absolute
			z-index 30

			img
				width 100%

			&.image-1
				left 40%
				top 150px
				width 15%

			&.image-2
				top 400px
				left -5%
				width 35%
			
			&.image-3
				right 15%
				top 250px
				width 25%
			
			&.image-4
				right 30%
				top 700px
				width 25%
			
			&.image-5
				bottom 70px
				right 8%
				width 10%
	
</style>


// WEBPACK FOOTER //
// youth-presentation.vue?0c7fbd71